import utils from '@/mixins/utils'

/**
 * Filtra os dados
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @param {Object|null} selectedEquipe
 * @param {Object|null} selectedFilterEquipe
 * @returns {Array}
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedEquipe = null,
  selectedFilterEquipe = null
) {
  return cadastros
    .map((item) => {
      const procedimentos = JSON.parse(item.procedimentos || '[]')

      const filtroSelecionado =
        selectedFilterEquipe != null ? selectedFilterEquipe.value : null

      const procedimentosBase = procedimentos.map((proc) => {
        const ineProcedimento = proc.nu_ine
        const ineEquipeSelecionada = selectedEquipe?.ine_esb ?? null

        const ehMinhaEquipe = ineProcedimento === ineEquipeSelecionada
        const ehOutrasEquipes = ineProcedimento !== ineEquipeSelecionada
        const ehFiltroTodas = filtroSelecionado === null

        const nomeProcedimento = (proc.no_proced || '').toLowerCase()
        const ehExodontia = nomeProcedimento.includes('exodontia')

        let pertenceAoFiltroEquipe = false

        if (ehFiltroTodas) {
          pertenceAoFiltroEquipe = true
        } else if (filtroSelecionado === 'minha-equipe') {
          pertenceAoFiltroEquipe = ehMinhaEquipe
        } else if (filtroSelecionado === 'outras-equipes') {
          pertenceAoFiltroEquipe = ehOutrasEquipes
        }

        let exibirNaTabela = false

        if (exibirVermelhos === true) {
          exibirNaTabela = pertenceAoFiltroEquipe && ehExodontia
        } else if (exibirVerdes === true) {
          exibirNaTabela = pertenceAoFiltroEquipe
        } else {
          exibirNaTabela = pertenceAoFiltroEquipe
        }

        return {
          ...proc,
          ehExodontia,
          exibir_na_tabela: exibirNaTabela,
        }
      })

      const temProcedimentoVisivel = procedimentosBase.some(
        (proc) => proc.exibir_na_tabela
      )

      if (!temProcedimentoVisivel) {
        return null
      }

      let classTable = 'table-row-color-green'

      if (exibirVermelhos === true) {
        classTable = 'table-row-color-orange'
      } else if (exibirVerdes === true) {
        classTable = 'table-row-color-green'
      } else {
        const temExodontiaVisivel = procedimentosBase.some(
          (proc) => proc.exibir_na_tabela && proc.ehExodontia
        )

        classTable = temExodontiaVisivel
          ? 'table-row-color-orange'
          : 'table-row-color-green'
      }

      const procedimentosAtualizados = procedimentosBase.map((proc) => {
        let classe = ''

        if (
          classTable === 'table-row-color-green' &&
          proc.exibir_na_tabela &&
          proc.ehExodontia
        ) {
          classe = 'table-row-color-orange'
        }

        return {
          ...proc,
          class_table_interna: classe,
        }
      })

      return {
        ...item,
        class_table: classTable,
        procedimentos: JSON.stringify(procedimentosAtualizados),
      }
    })
    .filter(Boolean)
}
